module.exports = __webpack_public_path__ + "Wireframes6.png?916968bdb0a4d66d143703dae1ac06ee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Wireframes6.png
// module id = 120
// module chunks = 0